import clsx from 'clsx';

const EMOJI = { cafeteria: '🍕', toys: '🧸', general: '📦' };

export function WarehousePicker({ value, onChange, warehouses = [], error }) {
  return (
    <div>
      <div className={clsx('inline-flex items-center gap-1 p-1 bg-paper-2 rounded-[10px] w-full', error && 'ring-1 ring-red')}>
        {warehouses.map((w) => {
          const id = w._id || w.id;
          const active = String(value) === String(id);
          return (
            <button
              key={id}
              type="button"
              onClick={() => onChange(id)}
              className={clsx(
                'flex-1 px-2.5 py-2 rounded-[8px] text-[12.5px] font-semibold transition-colors',
                active ? 'bg-orange text-white shadow-orange-glow' : 'text-ink-2 hover:bg-white'
              )}
            >
              {EMOJI[w.type] || '📦'} {w.name}
            </button>
          );
        })}
        {warehouses.length === 0 ? (
          <div className="text-ink-3 text-[12.5px] px-3 py-2">لا توجد مخازن</div>
        ) : null}
      </div>
      {error ? <div className="text-red text-[11.5px] mt-1 font-semibold">{error}</div> : null}
    </div>
  );
}
